import request from "../../utils/NetWorkUtil";

export async function getBusinessCate() {
    return request('/api/BusinessCate', {
        method: 'GET',
    });
}

export async function getBusiness(params) {
    return request('/api/Business', {
        method: 'GET',
        params
    });
}
